import React, { useState } from "react";
import { Card, Col, Row, Space, Typography, Input, Table } from "antd";
const { Text, Link } = Typography;

const cardProp = {
  size: "small",
  headStyle: {
    fontSize: "14px",
    lineHeight: "8px",
    minHeight: "20px",
  },
};

const GOOGLELINK = "http://www.google.com/search?q=";

const ATTRCATEGORY = {
  basicInfo: {
    title: "Basic Info",
    category: ["basic"],
  },
  certification: {
    category: ["complianceCert", "datacenterCert"],
    title: "Certifications and Standards",
  },
  dataProtection: {
    category: [
      "encryptionDataRest",
      "encryptionInTransit",
      "datapertenancy",
      "EncryptTenantKey",
    ],
    title: "Data Protection",
  },
  dataProtection2: {
    title: "Data Protection",
    category: [
      "dataClassification",
      "classificationCapabilities",
      "FS",
      "FSsize",
    ],
  },
  accessControl: {
    category: [
      "roleAuthBased",
      "granularpolicies",
      "multifactor",
      "devicerestrictions",
    ],
    title: "Access Control",
  },
  accessControl2: {
    category: ["SSOADhooks", "ipfilter", "EnforcePassword", "adminauditlogs"],
    title: "Access Control",
  },
  disasterRecovery: {
    category: ["disasterecovery", "hostinggeo", "hostinggeoback"],
    title: "Disaster Recovery",
  },
  disasterRecovery2: {
    category: ["infrahealth", "notificationLeadTime"],
    title: "Disaster Recovery",
  },
  legal: {
    category: [
      "dataOwnership",
      "DataAvailabilityPostDereg",
      "DataRetentionAtSaaSPostDereg",
    ],
    title: "Legal & Privacy",
  },
  legal2: {
    category: ["cookies_3rd_party", "sharing_personal_info_3rd_party"],
    title: "Legal & Privacy",
  },
};

const KEYWORDS = {
  basic: {
    title: "Basic",
    keywords: [
      "Login",
      "Sign in",
      "Address",
      "Contact",
      "Privacy",
      "Terms",
      "Linkedin",
      "Crunchbase",
      "Cloud",
      "cloud",
      "Saas",
      "Hosted on",
      "Centralized database",
      "Knowledge based",
      "Web based",
      "Breach",
      "GDPR",
    ],
  },
  complianceCert: {
    title: "Compliance Certification",
    keywords: [
      "PCI DSS",
      "Payment card industry data security",
      "standard",
      "HIPAA",
      "FedRamp",
      "Truste",
      "COBIT",
      "GAPP",
      "Privacy Shield",
      "PrivacyMark",
    ],
  },
  datacenterCert: {
    title: "Data centers Certification",
    keywords: [
      "Certifications",
      "SAS 70",
      "SSAE 16",
      "SOC1",
      "SOC2",
      "SOC3",
      "ISO 27018",
      "ISO 27001",
      "SP800-53",
      "Cyber Essentials",
      "C5",
    ],
  },
  encryptionDataRest: {
    title: "Data Encryption at rest",
    keywords: [
      "Encrypted database",
      "Encryption at rest",
      "storage encryption",
      "Encryption",
      "Encrypt database",
    ],
  },
  encryptionInTransit: {
    title: "Data Encryption in transit",
    keywords: [
      "Encryption in transit",
      "SSL",
      "Encrpytion",
      "https",
      "	Encrypt",
    ],
  },
  datapertenancy: {
    title: "Data segregated by tenant",
    keywords: [
      "Single tenant",
      "Multi tenant",
      "Isolated database",
      "Segregated database",
      "Segregation",
      "Separate database",
      "Logically separation",
      "Logically separated database",
    ],
  },
  EncryptTenantKey: {
    title: "Encryption with tenant managed keys",
    keywords: [
      "Encryption managed key",
      "Customer managed key",
      "Key management",
      "User managed key",
      "User management",
      "Tenant managed key",
    ],
  },
  dataClassification: {
    title: "Data Classification Capability",
    keywords: [
      "Data classification",
      "Content classification",
      "Data public",
      "Data private",
      "Public data",
      "Private data",
      "Folder permissions",
    ],
  },
  classificationCapabilities: {
    title: "Access Control",
    keywords: ["Access controls", "Classification permissions"],
  },
  FS: {
    title: "File Sharing",
    keywords: [
      "File sharing",
      "Information sharing",
      "Sharing",
      "Share",
      "File Attachments",
    ],
  },
  FSsize: {
    title: "File Sharing Capacity",
    keywords: ["File Size", "File Capacity"],
  },
  anonymousFileSharing: {
    title: "Anonymous sharing of data",
    keywords: ["Anonymous sharing", "Unknown sharing"],
  },
  roleAuthBased: {
    title: "Role and Auth Based Support",
    keywords: [
      "Role based access",
      "Roles",
      "User levels",
      "Admin",
      "User",
      "Access controls",
      "Permissions",
      "Levels",
    ],
  },
  granularpolicies: {
    title: "Granular Action Based Authorization Policies",
    keywords: [
      "Permissions",
      "Granular permissions",
      "Privileges",
      "Access Privileges",
    ],
  },
  multifactor: {
    title: "Multi-factor authentication",
    keywords: [
      "Two factor authentication",
      "Multi factor authentication",
      "Two step verification",
      "Strong authentication",
    ],
  },
  devicerestrictions: {
    title: "Devices Supported",
    keywords: ["IOS", "itunes", "android", "windows", "Blackberry", "Desktop"],
  },
  SSOADhooks: {
    title: "SSO/AD Hooks",
    keywords: ["SSO", "Single Sign On", "SAML", "OPENID", "OAUTH"],
  },
  ipfilter: {
    title: "IP Filtering (Restrict IP)",
    keywords: [
      "Whitelist IP",
      "IP restrict",
      "IP block",
      "IP filter",
      "IP whitelist",
      "IP range",
      "IP",
    ],
  },
  EnforcePassword: {
    title: "Enforceable best practices for passwords",
    keywords: [
      "Strong password",
      "Password policies",
      "Enforceable passwords",
      "Password strength",
      "Character password",
      "Numeric password",
      "Complex password",
    ],
  },
  adminauditlogs: {
    title: "Audit log",
    keywords: [
      "Audit trails",
      "User audit logs",
      "Data access logs",
      "Admin audit logs",
      "History of data",
      "Logs",
      "Access logs",
      "changes logs",
    ],
  },
  disasterecovery: {
    title: "Disaster Recovery",
    keywords: [
      "Recovery",
      "Disaster recovery",
      "Business continuity",
      "Redundant data/ database",
    ],
  },
  hostinggeo: {
    title: "Data Center",
    keywords: [
      "Geographical datacenters",
      "Datacenters",
      "Multiple datacenters",
      "Multiple servers",
      "Hosted on",
    ],
  },
  hostinggeoback: {
    title: "Data Backup",
    keywords: [
      "Offsite backup",
      "Backup",
      "Offsite",
      "Separate backup",
      "Offline backup",
    ],
  },
  infrahealth: {
    title: "Infrastructure Status",
    keywords: ["Status", "Uptime", "Downtime", "App Status", "System status"],
  },
  notificationLeadTime: {
    title: "Change/Upgrade Notifications",
    keywords: [
      "Change notifications",
      "upgrade notifications",
      "Hardware changes",
      "Data center downtime",
      "Software change",
      "Notifications",
      "New datacenters",
      "Schedule maintenance",
    ],
  },
  dataOwnership: {
    title: "Data Ownership",
    keywords: ["Own", "Sole", "Rights", "Responsible", "Claim", "Retain"],
  },
  DataAvailabilityPostDereg: {
    title: "Download on Cancellation",
    keywords: ["Available immediately", "Immediately"],
  },
  DataRetentionAtSaaSPostDereg: {
    title: "Account Cancellation",
    keywords: [
      "Termination",
      "Account cancellation",
      "deletion",
      "delete",
      "remove",
      "destroy",
      "Erase",
    ],
  },
  cookies_3rd_party: {
    title: "Third-party cookies",
    keywords: ["cookies", "Analysis", "google"],
  },
  sharing_personal_info_3rd_party: {
    title: "Share personal information",
    keywords: ["Sharing", "Share", "Third party"],
  },
};

const SearchPage = (props) => {
  const [searchWord, setSearchWord] = useState("");

  const onInputChange = (e) => {
    console.log(e.target.value);
    setSearchWord(e.target.value);
  };
  return (
    <>
      <Row justify={"center"}>
        <Col span={6}>
          <Input
            size={"small"}
            placeholder="Place App Domain"
            onChange={onInputChange}
          />
        </Col>
      </Row>
      {Object.keys(ATTRCATEGORY).map((attrcat) => {
        return (
          <Row gutter={[16, 16]} style={{ marginTop: "5px" }}>
            <Col span={24}>
              <Card title={ATTRCATEGORY[attrcat].title} {...cardProp}>
                <Row gutter={[16, 16]}>
                  {ATTRCATEGORY[attrcat].category.map((cat) => {
                    return (
                      <Col span={24 / ATTRCATEGORY[attrcat].category.length}>
                        {ATTRCATEGORY[attrcat].category.length == 1 ? (
                          <Space>
                            {KEYWORDS[cat].keywords.map((i) => {
                              return (
                                <Link
                                  href={GOOGLELINK + searchWord + " " + i}
                                  target={"_blank"}
                                >
                                  {i}
                                </Link>
                              );
                            })}
                          </Space>
                        ) : (
                          <Table
                            size={"small"}
                            columns={[
                              {
                                title: KEYWORDS[cat].title,
                                dataIndex: "keywords",
                                render: (text) => (
                                  <Link
                                    href={GOOGLELINK + searchWord + " " + text}
                                    target={"_blank"}
                                  >
                                    {text}
                                  </Link>
                                ),
                              },
                            ]}
                            dataSource={KEYWORDS[cat].keywords.map((i) => {
                              return { keywords: i };
                            })}
                            pagination={false}
                            style={{ width: "100%" }}
                          ></Table>
                        )}
                      </Col>
                    );
                  })}
                </Row>
              </Card>
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default SearchPage;
